import { Lender } from '@1delta/lender-registry'
import { Call } from '../../../utils/multicall'
import { getInitLensAddress } from '../addresses/init'

export const INIT_MODES = [1, 2, 3, 4, 5, 6]

export const INIT_EMODE_LABELS: { [mode: number]: string } = {
  [1]: 'Default',
  [2]: 'Blue Chip Volatile',
  [3]: 'Stablecoins',
  [4]: 'ETH correlated',
  [5]: 'Ethena',
  [6]: 'BTC',
}

export const buildInitStyleLenderReserveCall = (
  chainId: string,
  lender: Lender,
) => {
  const lensAddress = getInitLensAddress(chainId)
  const calls: Call[] = INIT_MODES.map((mode) => {
    return {
      address: lensAddress,
      name: 'getMarketData',
      params: [mode],
    }
  })

  return calls
}
